module.exports = __webpack_public_path__ + "media/images/select-arrows-icon-b7cfb5b0a7f9f9c9aab875579bed40fc.svg";